<template>
  <b-container fluid>
    <page-title icon="fas fa-tachometer-alt">
      <template #extras>
        <b-button variant="secondary" size="sm" :to="'/new/argh'">+ NEW</b-button>
      </template>
      <translate>Summary</translate>
    </page-title>
    <h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1><h1>Dummy Doo</h1>
  </b-container>
</template>
<script>
export default {
  name: 'DummyPage',
  title() {
    return this.$gettext('Dummy')
  }
}
</script>
